import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const l = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 134 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C.jsx("g", { clipPath: "url(#clip0_6941_7746)", children: /* @__PURE__ */ C.jsxs("g", { clipPath: "url(#clip1_6941_7746)", children: [
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M49.3645 68.753C52.2632 67.5577 54.9919 65.9862 57.4806 64.079C59.354 62.6384 61.0793 61.0149 62.6308 59.2323C61.1975 60.8155 59.4909 62.1279 57.5927 63.1066C54.9528 64.49 52.005 65.1812 49.0252 65.1155C46.0455 65.0498 43.131 64.2294 40.5546 62.731C38.9836 61.8279 37.5545 60.6979 36.3133 59.3777C35.8849 58.9329 35.4804 58.4658 35.1015 57.9782C34.0335 56.6499 33.0635 55.2457 32.1992 53.7767C30.962 51.6531 29.9468 49.4077 29.1697 47.0761C26.966 40.5024 26.7228 33.4295 28.4699 26.7199C28.6759 25.9354 28.9061 25.1569 29.1667 24.3814C24.8338 23.5031 20.3754 23.4374 16.0186 24.1875C13.4092 24.6145 10.9274 25.6163 8.75292 27.1204C6.57846 28.6246 4.76573 30.5934 3.44604 32.8843C2.01406 35.3604 1.20037 38.1452 1.07394 41.0026C0.967764 43.3485 1.32498 45.6923 2.12518 47.9001L2.20698 48.1303C5.09009 55.9532 10.6278 62.5163 17.8545 66.675C22.595 69.416 27.9029 71.0292 33.367 71.3895C38.8312 71.7499 44.305 70.8478 49.3645 68.753Z",
        fill: "url(#paint0_linear_6941_7746)"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M57.5008 7.39895C55.0166 5.48516 52.2908 3.90746 49.3938 2.70671C47.2119 1.80788 44.9457 1.12901 42.6289 0.680176C44.7168 1.12832 46.7067 1.94924 48.5032 3.10353C51.0183 4.69955 53.0877 6.90704 54.5182 9.51971C55.9486 12.1324 56.6934 15.065 56.6829 18.0435C56.6863 19.8564 56.423 21.6599 55.9012 23.3961C55.7292 23.9877 55.527 24.5701 55.2953 25.1409C54.6787 26.7291 53.9466 28.27 53.105 29.7514C51.8843 31.885 50.4479 33.8876 48.8182 35.728C44.2294 40.9199 38.2298 44.6656 31.5499 46.5089C30.7683 46.7239 29.9776 46.9148 29.1748 47.0753C30.5802 51.2673 32.753 55.1613 35.5822 58.559C37.257 60.6044 39.3655 62.2519 41.7553 63.3825C44.145 64.513 46.7562 65.0983 49.3999 65.096C52.2607 65.0985 55.0799 64.4117 57.619 63.0937C59.7041 62.0109 61.5567 60.53 63.0721 58.7347L63.2297 58.5469C68.5643 52.1392 71.4796 44.0622 71.4669 35.7249C71.4701 30.2482 70.2119 24.8444 67.79 19.9322C65.368 15.02 61.8474 10.7315 57.5008 7.39895Z",
        fill: "url(#paint1_linear_6941_7746)"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M0.309044 31.0397C-0.103015 34.1482 -0.103015 37.2975 0.309044 40.4059C0.615913 42.7463 1.15689 45.0499 1.9238 47.2822C1.26646 45.2497 0.981144 43.1153 1.08159 40.9815C1.21605 37.9863 2.1031 35.0732 3.66086 32.5112C5.21862 29.9493 7.39685 27.8211 9.99442 26.3232C11.5391 25.4298 13.2086 24.7723 14.9477 24.3724C15.5479 24.2399 16.1547 24.1388 16.7654 24.0695C18.4623 23.8139 20.1754 23.6813 21.8913 23.6727C24.3496 23.6613 26.8024 23.9039 29.2107 24.3967C36.0057 25.7764 42.2527 29.1022 47.1909 33.9689C47.7665 34.5384 48.327 35.1291 48.8662 35.744C51.8032 32.4364 54.091 28.6054 55.6099 24.4512C56.5297 21.9759 56.8946 19.3289 56.6789 16.6971C56.4632 14.0653 55.6722 11.513 54.3618 9.22039C52.9342 6.7414 50.9294 4.64339 48.5178 3.10445C46.5391 1.84042 44.3311 0.977911 42.0195 0.566L41.7771 0.520555C33.5514 -0.901784 25.0875 0.612194 17.8651 4.79778C13.1209 7.53127 9.06962 11.3201 6.02519 15.8707C2.98077 20.4214 1.02488 25.6117 0.309044 31.0397Z",
        fill: "url(#paint2_linear_6941_7746)"
      }
    )
  ] }) }),
  /* @__PURE__ */ C.jsx("rect", { x: "62.5337", width: "71.4667", height: "71.4667", rx: "35.7333", fill: "white" }),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M112.358 28.063C111.944 23.6901 108.172 22.2191 103.407 21.795L103.415 15.7302L99.7238 15.7255L99.7158 21.6304C98.7454 21.6291 97.7533 21.6469 96.7678 21.6652L96.7766 15.7212L93.087 15.716L93.0772 21.779C92.2779 21.7942 91.493 21.8079 90.7277 21.8074L90.7272 21.7885L85.5791 21.8101L85.5955 25.7358C85.5955 25.7358 88.1713 25.7241 88.3119 25.7244C89.8072 25.7269 90.2926 26.5957 90.4331 27.345L90.4096 43.959C90.3433 44.4295 90.0656 45.1795 89.021 45.1798C89.0681 45.2217 86.3375 45.1754 86.3375 45.1754L85.5978 49.583L90.4019 49.5895C91.2959 49.5918 92.1755 49.6082 93.039 49.6149L93.032 55.7487L96.7196 55.7544L96.728 49.6855C97.7405 49.7078 98.7203 49.7173 99.6769 49.7177L99.6669 55.7587L103.358 55.7635L103.368 49.6406C109.575 49.2931 113.921 47.7357 114.468 41.9083C114.91 37.216 112.706 35.1189 109.184 34.268C111.326 33.1812 112.667 31.2628 112.358 28.063ZM96.8209 45.2216C99.3228 45.2227 107.171 45.7551 107.175 41.1712C107.182 36.3902 99.3358 37.0988 96.8332 37.0947L96.8209 45.2216ZM96.8488 26.004L96.8383 33.3747C97.0119 33.3749 97.2164 33.3786 97.4456 33.3827C99.9673 33.4277 105.468 33.5258 105.474 29.7029C105.479 25.793 100.19 25.9257 97.6064 25.9905C97.3158 25.9978 97.0595 26.0043 96.8488 26.004Z",
      fill: "#FF9D27"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M98.267 68.6795C116.463 68.6795 131.213 53.929 131.213 35.7333C131.213 17.5377 116.463 2.7872 98.267 2.7872C80.0714 2.7872 65.3209 17.5377 65.3209 35.7333C65.3209 53.929 80.0714 68.6795 98.267 68.6795ZM98.267 71.4667C118.002 71.4667 134 55.4683 134 35.7333C134 15.9984 118.002 0 98.267 0C78.532 0 62.5337 15.9984 62.5337 35.7333C62.5337 55.4683 78.532 71.4667 98.267 71.4667Z",
      fill: "#313131"
    }
  ),
  /* @__PURE__ */ C.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M120.547 55.0388L118.441 53.2127C122.504 48.5281 124.96 42.421 124.96 35.7333C124.96 29.0457 122.504 22.9386 118.441 18.254L120.547 16.4279C125.033 21.6 127.747 28.3497 127.747 35.7333C127.747 43.117 125.032 49.8667 120.547 55.0388ZM117.573 13.4534L115.746 15.559C111.062 11.4963 104.955 9.04053 98.267 9.04053C91.5794 9.04053 85.4723 11.4963 80.7877 15.559L78.9615 13.4534C84.1337 8.96786 90.8833 6.25333 98.267 6.25333C105.651 6.25333 112.4 8.96786 117.573 13.4534ZM75.9871 16.4279C71.5015 21.6 68.787 28.3497 68.787 35.7333C68.787 43.117 71.5015 49.8667 75.9871 55.0388L78.0927 53.2127C74.03 48.5281 71.5742 42.421 71.5742 35.7333C71.5742 29.0457 74.03 22.9386 78.0927 18.254L75.9871 16.4279ZM78.9615 58.0133L80.7877 55.9076C85.4723 59.9704 91.5794 62.4261 98.267 62.4261C104.955 62.4261 111.062 59.9704 115.746 55.9076L117.572 58.0133C112.4 62.4988 105.651 65.2133 98.267 65.2133C90.8833 65.2133 84.1337 62.4988 78.9615 58.0133Z",
      fill: "#313131"
    }
  ),
  /* @__PURE__ */ C.jsxs("defs", { children: [
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_6941_7746",
        x1: "2.81289",
        y1: "33.6235",
        x2: "56.7415",
        y2: "64.6535",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#92E9FF" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_6941_7746",
        x1: "42.5835",
        y1: "62.7847",
        x2: "61.2508",
        y2: "9.12736",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#79FC9C" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint2_linear_6941_7746",
        x1: "55.9644",
        y1: "15.2788",
        x2: "0.454987",
        y2: "27.1678",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#FF91D1" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsx("clipPath", { id: "clip0_6941_7746", children: /* @__PURE__ */ C.jsx("rect", { width: "71.4667", height: "71.4667", fill: "white" }) }),
    /* @__PURE__ */ C.jsx("clipPath", { id: "clip1_6941_7746", children: /* @__PURE__ */ C.jsx("rect", { width: "71.4667", height: "71.4667", fill: "white" }) })
  ] })
] });
export {
  l as T
};
